/* eslint-disable*/
//
// traceit.js v1.0 is an error monitoring & reporting for JavaScript 
// work both in the browser It provides a simple solution for
// Automatically detecting JavaScript errors in the browser.Get platform error
// detection for handled and unhandled errors with  real-time error alerts and 
//detailed diagnostic reports.
//
// (c) THiru,  2019  


(function (f) {
  if (typeof exports === "object" && typeof module !== "undefined") { module.exports = f() }
  else if (typeof define === "function" && define.amd) { define([], f) }
  else {
     var g;
      if (typeof window !== "undefined") { g = window } 
     else if (typeof global !== "undefined") { g = global } 
     else if (typeof window.self !== "undefined") { g = window.self } else { g = this } g.traceit = f() }
})(function () {

  // Helper functions to support traceit ~ Thiru 08-oct-2019

  var define, module, exports;
  // Array#reduce
  var reduce = function (arr, fn, accum) {
    var val = accum;

    for (var i = 0, len = arr.length; i < len; i++) {
      val = fn(val, arr[i], i, arr);
    }

    return val;
  };

  // Array#filter

  var filter = function (arr, fn) {
    return reduce(arr, function (accum, item, i, arr) {
      return !fn(item, i, arr) ? accum : accum.concat(item);
    }, []);
  };
  // Array#map

  var map = function (arr, fn) {
    return reduce(arr, function (accum, item, i, arr) {
      return accum.concat(fn(item, i, arr));
    }, []);
  };
  // Array#includes

  var includes = function (arr, x) {
    return reduce(arr, function (accum, item, i, arr) {
      return accum === true || item === x;
    }, false);
  };

  var _hasDontEnumBug = !{
    toString: null
  }.propertyIsEnumerable('toString');

  var _dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor']; // Object#keys

  var keys = function (obj) {

    var result = [];
    var prop;

    for (prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) result.push(prop);
    }

    if (!_hasDontEnumBug) return result;

    for (var i = 0, len = _dontEnums.length; i < len; i++) {
      if (Object.prototype.hasOwnProperty.call(obj, _dontEnums[i])) result.push(_dontEnums[i]);
    }

    return result;
  };
  // Array#isArray

  var isArray = function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  };

  var _pad = function (n) {
    return n < 10 ? "0" + n : n;
  };
  // Date#toISOString

  var isoDate = function () {
    var d = new Date();
    return d.getUTCFullYear() + '-' + _pad(d.getUTCMonth() + 1) + '-' + _pad(d.getUTCDate()) + ' ' + _pad(d.getUTCHours()) + ':' + _pad(d.getUTCMinutes()) + ':' + _pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
  };


  var localDate = function () { // Remove milliseconds ~ Thiru 10-oct-2019
    var d = new Date();
  // return d.getFullYear() + '-' + _pad(d.getMonth() + 1) + '-' + _pad(d.getDate()) + ' ' + _pad(d.getHours()) + ':' + _pad(d.getMinutes()) + ':' + _pad(d.getSeconds()) + '.' + (d.getMilliseconds() / 1000).toFixed(3).slice(2, 5) ;
    return d.getFullYear() + '-' + _pad(d.getMonth() + 1) + '-' + _pad(d.getDate()) + ' ' + _pad(d.getHours()) + ':' + _pad(d.getMinutes()) + ':' + _pad(d.getSeconds()) ;
  };

  var _$esUtils = {
    map: map,
    reduce: reduce,
    filter: filter,
    includes: includes,
    keys: keys,
    isArray: isArray,
    isoDate: isoDate, //UTC Date ~ Thiru
    localDate: localDate //Local Date ~ Thiru
  };

  var _$validators = {};
  _$validators.intRange = function (min, max) {
    if (min === void 0) {
      min = 1;
    }

    if (max === void 0) {
      max = Infinity;
    }

    return function (value) {
      return typeof value === 'number' && parseInt('' + value, 10) === value && value >= min && value <= max;
    };
  };

  _$validators.stringWithLength = function (value) {
    return typeof value === 'string' && !!value.length;
  };

  var _$traceit_config = {};
  var __filter = _$esUtils.filter,
    __reduce = _$esUtils.reduce,
    __keys = _$esUtils.keys,
    __isArray = _$esUtils.isArray,
    __includes = _$esUtils.includes;

  var intRange = _$validators.intRange,
    stringWithLength = _$validators.stringWithLength;

  _$traceit_config.schema = {
    apiKey: {
      defaultValue: function () {
        return null;
      },
      message: 'is required',
      validate: stringWithLength
    },
    appName: {
      defaultValue: function () {
        return null;
      },
      message: 'should be a string',
      validate: function (value) {
        return value === null || stringWithLength(value);
      }
    },
    appModuleName: {
      defaultValue: function () {
        return null;
      },
      message: 'should be a string',
      validate: function (value) {
        return value === null || stringWithLength(value);
      }
    },
    appVersion: {
      defaultValue: function () {
        return null;
      },
      message: 'should be a string',
      validate: function (value) {
        return value === null || stringWithLength(value);
      }
    },
    appType: {
      defaultValue: function () {
        return null;
      },
      message: 'should be a string',
      validate: function (value) {
        return value === null || stringWithLength(value);
      }
    },
    autoNotify: {
      defaultValue: function () {
        return true;
      },
      message: 'should be true|false',
      validate: function (value) {
        return value === true || value === false;
      }
    },
    beforeSend: {
      defaultValue: function () {
        return [];
      },
      message: 'should be a function or array of functions',
      validate: function (value) {
        return typeof value === 'function' || __isArray(value) && __filter(value, function (f) {
          return typeof f === 'function';
        }).length === value.length;
      }
    },
    endpoints: {
      defaultValue: function () {
        return {
          notify: 'http://localhost:65531',
          sessions: 'http://localhost:65531',
        };
      },
      message: 'should be an object containing endpoint URLs { notify, sessions }. sessions is optional if autoRecordSessions=false',
      validate: function (val, obj) {
        return (
          val && typeof val === 'object' && 
          stringWithLength(val.notify) && ( 
            obj.autoRecordSessions === false || stringWithLength(val.sessions)) && 
          __filter(__keys(val), function (k) {
            return !__includes(['notify', 'sessions'], k);
          }).length === 0
        );
      }
    },
    autoRecordSessions: {
      defaultValue: function (val, opts) {
        return opts.endpoints === undefined || !!opts.endpoints && !!opts.endpoints.sessions;
      },
      message: 'should be true|false',
      validate: function (val) {
        return val === true || val === false;
      }
    },
    notifyDeliveryStages: {
      defaultValue: function () {
        return null;
      },
      message: 'should be an array of strings',
      validate: function (value) {
        return value === null || __isArray(value) && __filter(value, function (f) {
          return typeof f === 'string';
        }).length === value.length;
      }
    },
    deliveryStage: {
      defaultValue: function () {
        return 'production';
      },
      message: 'should be a string',
      validate: function (value) {
        return typeof value === 'string' && value.length;
      }
    },
    maxActivities: {
      defaultValue: function () {
        return 20;
      },
      message: 'should be a number ≤40',
      validate: function (value) {
        return intRange(0, 40)(value);
      }
    },
    autoRecordActivites: {
      defaultValue: function () {
        return true;
      },
      message: 'should be true|false',
      validate: function (value) {
        return typeof value === 'boolean';
      }
    },
    user: {
      defaultValue: function () {
        return null;
      },
      message: '(object) user should be an object',
      validate: function (value) {
        return typeof value === 'object';
      }
    },
    customData: {
      defaultValue: function () {
        return null;
      },
      message: 'should be an object',
      validate: function (value) {
        return typeof value === 'object';
      }
    },
    logger: {
      defaultValue: function () {
        return undefined;
      },
      message: 'should be null or an object with methods { debug, info, warn, error }',
      validate: function (value) {
        return !value || value && __reduce(['debug', 'info', 'warn', 'error'], function (accum, method) {
          return accum && typeof value[method] === 'function';
        }, true);
      }
    },
    filters: {
      defaultValue: function () {
        return ['password'];
      },
      message: 'should be an array of strings|regexes',
      validate: function (value) {
        return __isArray(value) && value.length === __filter(value, function (s) {
          return typeof s === 'string' || s && typeof s.test === 'function';
        }).length;
      }
    }
  };

  _$traceit_config.mergeDefaults = function (opts, schema) {
    if (!opts || !schema) throw new Error('opts and schema objects are required');
    return __reduce(__keys(schema), function (accum, key) {
      accum[key] = opts[key] !== undefined ? opts[key] : schema[key].defaultValue(opts[key], opts);
      return accum;
    }, {});
  };

  _$traceit_config.validate = function (opts, schema) {
    if (!opts || !schema) throw new Error('opts and schema objects are required');
    var errors = __reduce(__keys(schema), function (accum, key) {
      if (schema[key].validate(opts[key], opts)) return accum;
      return accum.concat({
        key: key,
        message: schema[key].message,
        value: opts[key]
      });
    }, []);
    return {
      valid: !errors.length,
      errors: errors
    };
  };

  function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

  var schema = _$traceit_config.schema;

  var __map = _$esUtils.map;

  var __stringWithLength = _$validators.stringWithLength;

  var _$config_1 = {
    deliveryStage: {
      defaultValue: function () {
        if (/^localhost(:\d+)?$/.test(window.location.host)) return 'development';
        return 'production';
      },
      message: 'should be set',
      validate: __stringWithLength
    },
    logger: _extends({}, schema.logger, {
      defaultValue: function () {
        return (
          typeof console !== 'undefined' && typeof console.debug === 'function' ? getPrefixedConsole() : undefined
        );
      }
    })
  };

  var getPrefixedConsole = function () {
    var logger = {};
    var consoleLog = console['log'];
    __map(['debug', 'info', 'warn', 'error'], function (method) {
      var consoleMethod = console[method];
      logger[method] = typeof consoleMethod === 'function' ? consoleMethod.bind(console, '[traceit]') : consoleLog.bind(console, '[traceit]');
    });
    return logger;
  };

  var __isoDate_3 = _$esUtils.isoDate;

  var TraceitActivity =
    /*#__PURE__*/
    function () {
      function TraceitActivity(name, customData, type, timestamp) {
        if (name === void 0) {
          name = '[anonymous]';
        }

        if (customData === void 0) {
          customData = {};
        }

        if (type === void 0) {
          type = 'manual';
        }

        if (timestamp === void 0) {
          timestamp = __isoDate_3();
        }

        this.type = type;
        this.name = name;
        this.customData = customData;
        this.timestamp = timestamp;
      }

      var _proto = TraceitActivity.prototype;

      _proto.toJSON = function toJSON() {
       // console.log(this.customData);
        return {
          type: this.type,
          name: this.name,
          timestamp: this.timestamp,
          customData: this.customData
        };
      };

      return TraceitActivity;
    }();

  var _$traceitActivity= TraceitActivity;

   var _$asyncSome_6 = function (arr, fn, cb) {
    var length = arr.length;
    var index = 0;

    var next = function () {
      if (index >= length) return cb(null, false);
      fn(arr[index], function (err, result) {
        if (err) return cb(err, false);
        if (result === true) return cb(null, true);
        index++;
        next();
      });
    };

    next();
  };

  var _$inferReleaseStage_10 = function (client) {
    return client.app && typeof client.app.deliveryStage === 'string' ? client.app.deliveryStage : client.config.deliveryStage;
  };

  /**
   * Expose `isError`.
   */
  var _$isError_21 = isError;
  /**
   * Test whether `value` is error object.
   *
   * @param {*} value
   * @returns {boolean}
   */

  function isError(value) {
    switch (Object.prototype.toString.call(value)) {
      case '[object Error]':
        return true;

      case '[object Exception]':
        return true;

      case '[object DOMException]':
        return true;

      default:
        return value instanceof Error;
    }
  }

  var _$iserror_11 = _$isError_21;

  var _$runBeforeSend_14 = function (report, onError) {
    return function (fn, cb) {
      if (typeof fn !== 'function') return cb(null, false);

      try {
       
        if (fn.length !== 2) {
          var ret = fn(report); 

          if (ret && typeof ret.then === 'function') {
            return ret.then( // resolve
              function (val) {
                return setTimeout(function () {
                  return cb(null, shouldPreventSend(report, val));
                }, 0);
              }, // reject
              function (err) {
                setTimeout(function () {
                  onError(err);
                  return cb(null, false);
                });
              });
          }

          return cb(null, shouldPreventSend(report, ret));
        } // if function is async…


        fn(report, function (err, result) {
          if (err) {
            onError(err);
            return cb(null, false);
          }

          cb(null, shouldPreventSend(report, result));
        });
      } catch (e) {
        onError(e);
        cb(null, false);
      }
    };
  };

  var shouldPreventSend = function (report, value) {
    return report.isIgnored() || value === false;
  };

  var _$stackframe_23 = {};
  (function (root, factory) {
    'use strict';

    if (typeof define === 'function' && define.amd) {
      define('stackframe', [], factory);
    } else if (typeof _$stackframe_23 === 'object') {
      _$stackframe_23 = factory();
    } else {
      root.StackFrame = factory();
    }
  })(this, function () {
    'use strict';

    function _isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

    function _capitalize(str) {
      return str.charAt(0).toUpperCase() + str.substring(1);
    }

    function _getter(p) {
      return function () {
        return this[p];
      };
    }

    var booleanProps = ['isConstructor', 'isEval', 'isNative', 'isToplevel'];
    var numericProps = ['columnNumber', 'lineNumber'];
    var stringProps = ['fileName', 'functionName', 'source'];
    var arrayProps = ['args'];
    var props = booleanProps.concat(numericProps, stringProps, arrayProps);

    function StackFrame(obj) {
      if (obj instanceof Object) {
        for (var i = 0; i < props.length; i++) {
          if (obj.hasOwnProperty(props[i]) && obj[props[i]] !== undefined) {
            this['set' + _capitalize(props[i])](obj[props[i]]);
          }
        }
      }
    }

    StackFrame.prototype = {
      getArgs: function () {
        return this.args;
      },
      setArgs: function (v) {
        if (Object.prototype.toString.call(v) !== '[object Array]') {
          throw new TypeError('Args must be an Array');
        }

        this.args = v;
      },
      getEvalOrigin: function () {
        return this.evalOrigin;
      },
      setEvalOrigin: function (v) {
        if (v instanceof StackFrame) {
          this.evalOrigin = v;
        } else if (v instanceof Object) {
          this.evalOrigin = new StackFrame(v);
        } else {
          throw new TypeError('Eval Origin must be an Object or StackFrame');
        }
      },
      toString: function () {
        var functionName = this.getFunctionName() || '{anonymous}';
        var args = '(' + (this.getArgs() || []).join(',') + ')';
        var fileName = this.getFileName() ? '@' + this.getFileName() : '';
        var lineNumber = _isNumber(this.getLineNumber()) ? ':' + this.getLineNumber() : '';
        var columnNumber = _isNumber(this.getColumnNumber()) ? ':' + this.getColumnNumber() : '';
        return functionName + args + fileName + lineNumber + columnNumber;
      }
    };

    for (var i = 0; i < booleanProps.length; i++) {
      StackFrame.prototype['get' + _capitalize(booleanProps[i])] = _getter(booleanProps[i]);

      StackFrame.prototype['set' + _capitalize(booleanProps[i])] = function (p) {
        return function (v) {
          this[p] = Boolean(v);
        };
      }(booleanProps[i]);
    }

    for (var j = 0; j < numericProps.length; j++) {
      StackFrame.prototype['get' + _capitalize(numericProps[j])] = _getter(numericProps[j]);

      StackFrame.prototype['set' + _capitalize(numericProps[j])] = function (p) {
        return function (v) {
          if (!_isNumber(v)) {
            throw new TypeError(p + ' must be a Number');
          }

          this[p] = Number(v);
        };
      }(numericProps[j]);
    }

    for (var k = 0; k < stringProps.length; k++) {
      StackFrame.prototype['get' + _capitalize(stringProps[k])] = _getter(stringProps[k]);

      StackFrame.prototype['set' + _capitalize(stringProps[k])] = function (p) {
        return function (v) {
          this[p] = String(v);
        };
      }(stringProps[k]);
    }

    return StackFrame;
  });

  var _$errorStackParser_20 = {};
  (function (root, factory) {
    'use strict'; 

    if (typeof define === 'function' && define.amd) {
      define('error-stack-parser', ['stackframe'], factory);
    } else if (typeof _$errorStackParser_20 === 'object') {
      _$errorStackParser_20 = factory(_$stackframe_23);
    } else {
      root.ErrorStackParser = factory(root.StackFrame);
    }
  })(this, function ErrorStackParser(StackFrame) {
    'use strict';

    var FIREFOX_SAFARI_STACK_REGEXP = /(^|@)\S+\:\d+/;
    var CHROME_IE_STACK_REGEXP = /^\s*at .*(\S+\:\d+|\(native\))/m;
    var SAFARI_NATIVE_CODE_REGEXP = /^(eval@)?(\[native code\])?$/;
    return {
      /**
       * Given an Error object, extract the most information from it.
       *
       * @param {Error} error object
       * @return {Array} of StackFrames
       */
      parse: function ErrorStackParser$$parse(error) {
        if (typeof error.stacktrace !== 'undefined' || typeof error['opera#sourceloc'] !== 'undefined') {
          return this.parseOpera(error);
        } else if (error.stack && error.stack.match(CHROME_IE_STACK_REGEXP)) {
          return this.parseV8OrIE(error);
        } else if (error.stack) {
          return this.parseFFOrSafari(error);
        } else {
          throw new Error('Cannot parse given Error object');
        }
      },
      
      extractLocation: function ErrorStackParser$$extractLocation(urlLike) {
        
        if (urlLike.indexOf(':') === -1) {
          return [urlLike];
        }

        var regExp = /(.+?)(?:\:(\d+))?(?:\:(\d+))?$/;
        var parts = regExp.exec(urlLike.replace(/[\(\)]/g, ''));
        return [parts[1], parts[2] || undefined, parts[3] || undefined];
      },
      parseV8OrIE: function ErrorStackParser$$parseV8OrIE(error) {
        var filtered = error.stack.split('\n').filter(function (line) {
          return !!line.match(CHROME_IE_STACK_REGEXP);
        }, this);
        return filtered.map(function (line) {
          if (line.indexOf('(eval ') > -1) {
            // Throw away eval information until we implement stacktrace.js/stackframe#8
            line = line.replace(/eval code/g, 'eval').replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, '');
          }

          var sanitizedLine = line.replace(/^\s+/, '').replace(/\(eval code/g, '('); // capture and preseve the parenthesized location "(/foo/my bar.js:12:87)" in
          // case it has spaces in it, as the string is split on \s+ later on

          var location = sanitizedLine.match(/ (\((.+):(\d+):(\d+)\)$)/); // remove the parenthesized location from the line, if it was matched

          sanitizedLine = location ? sanitizedLine.replace(location[0], '') : sanitizedLine;
          var tokens = sanitizedLine.split(/\s+/).slice(1); // if a location was matched, pass it to extractLocation() otherwise pop the last token

          var locationParts = this.extractLocation(location ? location[1] : tokens.pop());
          var functionName = tokens.join(' ') || undefined;
          var fileName = ['eval', '<anonymous>'].indexOf(locationParts[0]) > -1 ? undefined : locationParts[0];
          return new StackFrame({
            functionName: functionName,
            fileName: fileName,
            lineNumber: locationParts[1],
            columnNumber: locationParts[2],
            source: line
          });
        }, this);
      },
      parseFFOrSafari: function ErrorStackParser$$parseFFOrSafari(error) {
        var filtered = error.stack.split('\n').filter(function (line) {
          return !line.match(SAFARI_NATIVE_CODE_REGEXP);
        }, this);
        return filtered.map(function (line) {
          // Throw away eval information until we implement stacktrace.js/stackframe#8
          if (line.indexOf(' > eval') > -1) {
            line = line.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ':$1');
          }

          if (line.indexOf('@') === -1 && line.indexOf(':') === -1) {
            // Safari eval frames only have function names and nothing else
            return new StackFrame({
              functionName: line
            });
          } else {
            var functionNameRegex = /((.*".+"[^@]*)?[^@]*)(?:@)/;
            var matches = line.match(functionNameRegex);
            var functionName = matches && matches[1] ? matches[1] : undefined;
            var locationParts = this.extractLocation(line.replace(functionNameRegex, ''));
            return new StackFrame({
              functionName: functionName,
              fileName: locationParts[0],
              lineNumber: locationParts[1],
              columnNumber: locationParts[2],
              source: line
            });
          }
        }, this);
      },
      parseOpera: function ErrorStackParser$$parseOpera(e) {
        if (!e.stacktrace || e.message.indexOf('\n') > -1 && e.message.split('\n').length > e.stacktrace.split('\n').length) {
          return this.parseOpera9(e);
        } else if (!e.stack) {
          return this.parseOpera10(e);
        } else {
          return this.parseOpera11(e);
        }
      },
      parseOpera9: function ErrorStackParser$$parseOpera9(e) {
        var lineRE = /Line (\d+).*script (?:in )?(\S+)/i;
        var lines = e.message.split('\n');
        var result = [];

        for (var i = 2, len = lines.length; i < len; i += 2) {
          var match = lineRE.exec(lines[i]);

          if (match) {
            result.push(new StackFrame({
              fileName: match[2],
              lineNumber: match[1],
              source: lines[i]
            }));
          }
        }

        return result;
      },
      parseOpera10: function ErrorStackParser$$parseOpera10(e) {
        var lineRE = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i;
        var lines = e.stacktrace.split('\n');
        var result = [];

        for (var i = 0, len = lines.length; i < len; i += 2) {
          var match = lineRE.exec(lines[i]);

          if (match) {
            result.push(new StackFrame({
              functionName: match[3] || undefined,
              fileName: match[2],
              lineNumber: match[1],
              source: lines[i]
            }));
          }
        }

        return result;
      },
      // Opera 10.65+ Error.stack very similar to FF/Safari
      parseOpera11: function ErrorStackParser$$parseOpera11(error) {
        var filtered = error.stack.split('\n').filter(function (line) {
          return !!line.match(FIREFOX_SAFARI_STACK_REGEXP) && !line.match(/^Error created at/);
        }, this);
        return filtered.map(function (line) {
          var tokens = line.split('@');
          var locationParts = this.extractLocation(tokens.pop());
          var functionCall = tokens.shift() || '';
          var functionName = functionCall.replace(/<anonymous function(: (\w+))?>/, '$2').replace(/\([^\)]*\)/g, '') || undefined;
          var argsRaw;

          if (functionCall.match(/\(([^\)]*)\)/)) {
            argsRaw = functionCall.replace(/^[^\(]+\(([^\)]*)\)$/, '$1');
          }

          var args = argsRaw === undefined || argsRaw === '[arguments not available]' ? undefined : argsRaw.split(',');
          return new StackFrame({
            functionName: functionName,
            args: args,
            fileName: locationParts[0],
            lineNumber: locationParts[1],
            columnNumber: locationParts[2],
            source: line
          });
        }, this);
      }
    };
  });

  var _$errorStackParser_7 = _$errorStackParser_20;

 
  var _$hasStack_9 = function (err) {
    return !!err && (!!err.stack || !!err.stacktrace || !!err['opera#sourceloc']) && typeof (err.stack || err.stacktrace || err['opera#sourceloc']) === 'string' && err.stack !== err.name + ": " + err.message;
  };

  var _$jsRuntime_12 = "yes" ? 'browserjs' : typeof navigator !== 'undefined' && navigator.product === 'ReactNative' ? typeof Expo !== 'undefined' ? 'expojs' : 'reactnativejs' : 'nodejs';

  var _$stackGenerator_22 = {};
  (function (root, factory) {
    'use strict'; 

    if (typeof define === 'function' && define.amd) {
      define('stack-generator', ['stackframe'], factory);
    } else if (typeof _$stackGenerator_22 === 'object') {
      _$stackGenerator_22 = factory(_$stackframe_23);
    } else {
      root.StackGenerator = factory(root.StackFrame);
    }
  })(this, function (StackFrame) {
    return {
      backtrace: function StackGenerator$$backtrace(opts) {
        var stack = [];
        var maxStackSize = 10;

        if (typeof opts === 'object' && typeof opts.maxStackSize === 'number') {
          maxStackSize = opts.maxStackSize;
        }

        var curr = arguments.callee;

        while (curr && stack.length < maxStackSize && curr['arguments']) {
          // Allow V8 optimizations
          var args = new Array(curr['arguments'].length);

          for (var i = 0; i < args.length; ++i) {
            args[i] = curr['arguments'][i];
          }

          if (/function(?:\s+([\w$]+))+\s*\(/.test(curr.toString())) {
            stack.push(new StackFrame({
              functionName: RegExp.$1 || undefined,
              args: args
            }));
          } else {
            stack.push(new StackFrame({
              args: args
            }));
          }

          try {
            curr = curr.caller;
          } catch (e) {
            break;
          }
        }

        return stack;
      }
    };
  });

  function ___extends_24() { ___extends_24 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ___extends_24.apply(this, arguments); }

 

  var __reduce_24 = _$esUtils.reduce,
    __filter_24 = _$esUtils.filter;


  var TraceitReport =
   
    function () {
      function TraceitReport(errorClass, errorMessage, stacktrace, handledState, originalError) {
        if (stacktrace === void 0) {
          stacktrace = [];
        }

        if (handledState === void 0) {
          handledState = defaultHandledState();
        }

        
        this.__isTraceitReport = true;
        this._ignored = false; 

        this._handledState = handledState; 

        this.app = undefined;
        this.apiKey = undefined;
        this.reportedAt =undefined;
        this.activities = [];
        this.context = undefined;
        this.device = undefined;
        this.errorClass = stringOrFallback(errorClass, '[no error class]');
        this.errorMessage = stringOrFallback(errorMessage, '[no error message]');
        this.groupingHash = undefined;
        this.customData = {};
        this.request = undefined;
        this.severity = this._handledState.severity;
        this.stacktrace = __reduce_24(stacktrace, function (accum, frame) {
          var f = formatStackframe(frame); 

          try {
            if (JSON.stringify(f) === '{}') return accum;
            return accum.concat(f);
          } catch (e) {
            return accum;
          }
        }, []);
        this.user = undefined;
        this.session = undefined;
        this.originalError = originalError; 
      }

      var _proto = TraceitReport.prototype;

      _proto.ignore = function ignore() {
        this._ignored = true;
      };

      _proto.isIgnored = function isIgnored() {
        return this._ignored;
      };

      _proto.updateMetaData = function updateMetaData(section) {
        var _updates;

        if (!section) return this;
        var updates; 
        if ((arguments.length <= 1 ? undefined : arguments[1]) === null) return this.removeMetaData(section); // updateMetaData("section", "property", null) -> removes property from section

        if ((arguments.length <= 2 ? undefined : arguments[2]) === null) return this.removeMetaData(section, arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2]); // normalise the two supported input types into object form

        if (typeof (arguments.length <= 1 ? undefined : arguments[1]) === 'object') updates = arguments.length <= 1 ? undefined : arguments[1];
        if (typeof (arguments.length <= 1 ? undefined : arguments[1]) === 'string') updates = (_updates = {}, _updates[arguments.length <= 1 ? undefined : arguments[1]] = arguments.length <= 2 ? undefined : arguments[2], _updates); // exit if we don't have an updates object at this point

        if (!updates) return this; 

        if (!this.customData[section]) this.customData[section] = {}; 

        this.customData[section] = ___extends_24({}, this.customData[section], updates);
        return this;
      };

      _proto.removeMetaData = function removeMetaData(section, property) {
        if (typeof section !== 'string') return this; 

        if (!property) {
          delete this.customData[section];
          return this;
        } 


        if (this.customData[section]) {
          delete this.customData[section][property];
          return this;
        }

        return this;
      };

      _proto.toJSON = function toJSON() {
        return {
          payloadVersion: '1',
          exceptions: [{
            errorClass: this.errorClass,
            message: this.errorMessage,
            stacktrace: this.stacktrace,
            type: _$jsRuntime_12
          }],
          severity: this.severity,
          unhandled: this._handledState.unhandled,
          severityReason: this._handledState.severityReason,
          application: this.app,
          device: this.device,
          activities: this.activities,
          context: this.context,
          user: this.user,
          customData: this.customData,
          groupingHash: this.groupingHash,
          request: this.request,
          session: this.session
        };
      };

      return TraceitReport;
    }(); 


  var formatStackframe = function (frame) {
    var f = {
      file: frame.fileName,
      method: normaliseFunctionName(frame.functionName) || '{"method":"Not Available"}' ,
      lineNumber: frame.lineNumber,
      columnNumber: frame.columnNumber,
      code: {"code":"Not Available"},
      inProject: undefined 

    };

    if (f.lineNumber > -1 && !f.file && !f.method) {
      f.file = 'global code';
    }

    return f;
  };

  var normaliseFunctionName = function (name) {
    return /^global code$/i.test(name) ? 'global code' : name;
  };

  var defaultHandledState = function () {
    return {
      unhandled: false,
      severity: 'warning',
      severityReason: {
        type: 'handledException'
      }
    };
  };

  var stringOrFallback = function (str, fallback) {
    return typeof str === 'string' && str ? str : fallback;
  }; // Helpers


  TraceitReport.getStacktrace = function (error, errorFramesToSkip, generatedFramesToSkip) {
    if (errorFramesToSkip === void 0) {
      errorFramesToSkip = 0;
    }

    if (generatedFramesToSkip === void 0) {
      generatedFramesToSkip = 0;
    }

    if (_$hasStack_9(error)) return _$errorStackParser_7.parse(error).slice(errorFramesToSkip); // in IE11 a new Error() doesn't have a stacktrace until you throw it, so try that here

    try {
      throw error;
    } catch (e) {
      if (_$hasStack_9(e)) return _$errorStackParser_7.parse(error).slice(1 + generatedFramesToSkip); // error wasn't provided or didn't have a stacktrace so try to walk the callstack

      try {
        return __filter_24(_$stackGenerator_22.backtrace(), function (frame) {
          return (frame.functionName || '').indexOf('StackGenerator$$') === -1;
        }).slice(1 + generatedFramesToSkip);
      } catch (e) {
        return [];
      }
    }
  };

  TraceitReport.ensureReport = function (reportOrError, errorFramesToSkip, generatedFramesToSkip) {
    if (errorFramesToSkip === void 0) {
      errorFramesToSkip = 0;
    }

    if (generatedFramesToSkip === void 0) {
      generatedFramesToSkip = 0;
    }

   
    if (reportOrError.__isTraceitReport) return reportOrError;

    try {
      var stacktrace = TraceitReport.getStacktrace(reportOrError, errorFramesToSkip, 1 + generatedFramesToSkip);
      return new TraceitReport(reportOrError.name, reportOrError.message, stacktrace, undefined, reportOrError);
    } catch (e) {
      return new TraceitReport(reportOrError.name, reportOrError.message, [], undefined, reportOrError);
    }
  };

  var _$traceitReport = TraceitReport;

  var _$pad_18 = function pad(num, size) {
    var s = '000000000' + num;
    return s.substr(s.length - size);
  };

 

  var env = typeof window === 'object' ? window : window.self;
  var globalCount = 0;

  for (var prop in env) {
    if (Object.hasOwnProperty.call(env, prop)) globalCount++;
  }

  var mimeTypesLength = navigator.mimeTypes ? navigator.mimeTypes.length : 0;
  var clientId = _$pad_18((mimeTypesLength + navigator.userAgent.length).toString(36) + globalCount.toString(36), 4);

  var _$fingerprint_17 = function fingerprint() {
    return clientId;
  };

  
  var c = 0,
    blockSize = 4,
    base = 36,
    discreteValues = Math.pow(base, blockSize);

  function randomBlock() {
    return _$pad_18((Math.random() * discreteValues << 0).toString(base), blockSize);
  }

  function safeCounter() {
    c = c < discreteValues ? c : 0;
    c++; // this is not subliminal

    return c - 1;
  }

  function cuid() {
    var letter = 'c',

      timestamp = new Date().getTime().toString(base),
      
      counter = _$pad_18(safeCounter().toString(base), blockSize),

      print = _$fingerprint_17(),

      random = randomBlock() + randomBlock();
    return letter + timestamp + counter + print + random;
  }

  cuid.fingerprint = _$fingerprint_17;
  var _$cuid_16 = cuid;

  var __isoDate_25 = _$esUtils.isoDate;
  var __localDate_25 = _$esUtils.localDate;



  var Session =
  
    function () {
      function Session() {
        this.id = _$cuid_16();
        this.startedAt = __localDate_25();
        this._handled = 0;
        this._unhandled = 0;
      }

      var _proto = Session.prototype;

      _proto.toJSON = function toJSON() {
        return {
          id: this.id,
          startedAt: this.startedAt,
          eventsCount: {
            handled: this._handled,
            unhandled: this._unhandled
          }
        };
      };

      _proto.trackError = function trackError(report) {
        this[report._handledState.unhandled ? '_unhandled' : '_handled'] += 1;
      };

      return Session;
    }();

  var _$traceitSession = Session;

  function ___extends_4() { ___extends_4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ___extends_4.apply(this, arguments); }


  var __map_4 = _$esUtils.map,
    __includes_4 = _$esUtils.includes,
    __isArray_4 = _$esUtils.isArray;



  var LOG_USAGE_ERR_PREFIX = "Usage error.";
  var REPORT_USAGE_ERR_PREFIX = "traceit usage error.";

  var TraceitClient =
 
    function () {
      function TraceitClient(notifier) {
        if (!notifier || !notifier.name || !notifier.version || !notifier.url) {
          throw new Error('`notifier` argument is required');
        } // notifier id


        this.notifier = notifier; 

        this._configured = false; 

        this._opts = {};
        this.config = {}; 

        this._delivery = {
          sendSession: function () { },
          sendReport: function () { }
        };
        this._logger = {
          debug: function () { },
          info: function () { },
          warn: function () { },
          error: function () { } // plugins

        };
        this._plugins = {};
        this._session = null;
        this.activities = []; // setable props

        this.app = {};
        this.context = undefined;
        this.device = undefined;
        this.customData = undefined;
        this.request = undefined;
        this.user = {}; // expose internal constructors

        this.TraceitClient = _$traceitClient;
        this.TraceitReport = _$traceitReport;
        this.TraceitActivity = _$traceitActivity;
        this.TraceitSession = _$traceitSession;
        window.self = this;
        var notify = this.notify;

        this.notify = function () {
          return notify.apply(window.self, arguments);
        };
      }

      var _proto = TraceitClient.prototype;

      _proto.setOptions = function setOptions(opts) {
        this._opts = ___extends_4({}, this._opts, opts);
      };

      _proto.configure = function configure(partialSchema) {
        if (partialSchema === void 0) {
          partialSchema = _$traceit_config.schema;
        }

        var conf = _$traceit_config.mergeDefaults(this._opts, partialSchema);
        var validity = _$traceit_config.validate(conf, partialSchema);
        if (!validity.valid === true) throw new Error(generateConfigErrorMessage(validity.errors)); 

        if (typeof conf.beforeSend === 'function') conf.beforeSend = [conf.beforeSend];
        if (conf.appName) this.app.appName = conf.appName;
        if (conf.appModuleName) this.app.appModuleName = conf.appModuleName;
        if (conf.appType) this.app.type = conf.appType;
        if (conf.appVersion) this.app.version = conf.appVersion;
        if (conf.customData) this.customData = conf.customData;
        if (conf.user) this.user = conf.user;
        if (conf.logger) this.logger(conf.logger); // merge with existing config

        this.config = ___extends_4({}, this.config, conf);
        this._configured = true;
        return this;
      };

      _proto.use = function use(plugin) {
        if (!this._configured) throw new Error('client not configured');
        if (plugin.configSchema) this.configure(plugin.configSchema);

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var result = plugin.init.apply(plugin, [this].concat(args)); 

        if (plugin.name) this._plugins["~" + plugin.name + "~"] = result;
        return this;
      };

      _proto.getPlugin = function getPlugin(name) {
        return this._plugins["~" + name + "~"];
      };

      _proto.delivery = function delivery(d) {
        this._delivery = d(this);
        return this;
      };

      _proto.logger = function logger(l, sid) {
        this._logger = l;
        return this;
      };

      _proto.sessionDelegate = function sessionDelegate(s) {
        this._sessionDelegate = s;
        return this;
      };

      _proto.startSession = function startSession() {
        if (!this._sessionDelegate) {
          this._logger.warn('No session implementation is installed');

          return this;
        }

        return this._sessionDelegate.startSession(this);
      };

      _proto.leaveActivity = function leaveActivity(name, customData, type, timestamp) {
        if (!this._configured) throw new Error('client not configured'); // coerce bad values so that the defaults get set

        name = name || undefined;
        type = typeof type === 'string' ? type : undefined;
        timestamp = typeof timestamp === 'string' ? timestamp : undefined;
        customData = typeof customData === 'object' && customData !== null ? customData : undefined; // if no name and no customData, usefulness of this crumb is questionable at best so discard

        if (typeof name !== 'string' && !customData) return;
        var crumb = new _$traceitActivity(name, customData, type, timestamp); // push the valid crumb onto the queue and maintain the length

        this.activities.push(crumb);

        if (this.activities.length > this.config.maxActivities) {
          this.activities = this.activities.slice(this.activities.length - this.config.maxActivities);
        }

        return this;
      };

      _proto.notify = function notify(error, opts, cb) {
        var _this = this;

        if (opts === void 0) {
          opts = {};
        }

        if (cb === void 0) {
          cb = function () { };
        }

        if (!this._configured) throw new Error('client not configured'); // deliveryStage can be set via config.deliveryStage or client.app.deliveryStage

        var deliveryStage = _$inferReleaseStage_10(this); // ensure we have an error (or a reasonable object representation of an error)

        var _normaliseError = normaliseError(error, opts, this._logger),
          err = _normaliseError.err,
          errorFramesToSkip = _normaliseError.errorFramesToSkip,
          _opts = _normaliseError._opts;

        if (_opts) opts = _opts; // ensure opts is an object

        if (typeof opts !== 'object' || opts === null) opts = {}; // create a report from the error, if it isn't one already

        var report = _$traceitReport.ensureReport(err, errorFramesToSkip, 2);
        report.app = ___extends_4({}, {
          deliveryStage: deliveryStage
        }, report.app, this.app);
        report.context = report.context || opts.context || this.context || undefined;
        report.device = ___extends_4({}, report.device, this.device, opts.device);
        report.request = ___extends_4({}, report.request, this.request, opts.request);
        report.user = ___extends_4({}, report.user, this.user, opts.user);
        report.customData = ___extends_4({}, report.customData, this.customData, opts.customData);
        report.activities = this.activities.slice(0);

        if (this._session) {
          this._session.trackError(report);

          report.session = this._session;
        } // set severity if supplied


        if (opts.severity !== undefined) {
          report.severity = opts.severity;
          report._handledState.severityReason = {
            type: 'userSpecifiedSeverity'
          };
        } // exit early if the reports should not be sent on the current deliveryStage


        if (__isArray_4(this.config.notifyDeliveryStages) && !__includes_4(this.config.notifyDeliveryStages, deliveryStage)) {
          this._logger.warn("Report not sent due to deliveryStage/notifyDeliveryStages configuration");

          return cb(null, report);
        }

        var originalSeverity = report.severity;
        var beforeSend = [].concat(this._opts.beforeSend).concat(opts.beforeSend).concat(this.config.beforeSend);
        
        var onBeforeSendErr = function (err) {
          _this._logger.error("Error occurred in beforeSend callback, continuing anyway\u2026");

          _this._logger.error(err);
        };

        _$asyncSome_6(beforeSend, _$runBeforeSend_14(report, onBeforeSendErr), function (err, preventSend) {
          if (err) onBeforeSendErr(err);

          if (preventSend) {
            _this._logger.debug("Report not sent due to beforeSend callback");

            return cb(null, report);
          } // only leave a crumb for the error if actually got sent


          if (_this.config.autoRecordActivites) {
            _this.leaveActivity(report.errorClass, {
              errorClass: report.errorClass,
              errorMessage: report.errorMessage,
              severity: report.severity
            }, 'error');
          }

          if (originalSeverity !== report.severity) {
            report._handledState.severityReason = {
              type: 'userCallbackSetSeverity'
            };
          }
          var __localDate_26 = _$esUtils.localDate;
          _this._delivery.sendReport({
            apiKey: report.apiKey || _this.config.apiKey,
            reportedAt: __localDate_26(),
            notifier: _this.notifier,
            events: [report]
          }, function (err) {
            return cb(err, report);
          });
        });
      };

      return TraceitClient;
    }();

  var normaliseError = function (error, opts, logger) {
    var synthesizedErrorFramesToSkip = 3;

    var createAndLogUsageError = function (reason) {
      var msg = generateNotifyUsageMessage(reason);
      logger.warn(LOG_USAGE_ERR_PREFIX + " " + msg);
      return new Error(REPORT_USAGE_ERR_PREFIX + " " + msg);
    };

    var err;
    var errorFramesToSkip = 0;

    var _opts;

    switch (typeof error) {
      case 'string':
        if (typeof opts === 'string') {

          err = createAndLogUsageError('string/string');
          _opts = {
            customData: {
              notifier: {
                notifyArgs: [error, opts]
              }
            }
          };
        } else {
          err = new Error(String(error));
          errorFramesToSkip = synthesizedErrorFramesToSkip;
        }

        break;

      case 'number':
      case 'boolean':
        err = new Error(String(error));
        break;

      case 'function':
        err = createAndLogUsageError('function');
        break;

      case 'object':
        if (error !== null && (_$iserror_11(error) || error.__isTraceitReport)) {
          err = error;
        } else if (error !== null && hasNecessaryFields(error)) {
          err = new Error(error.message || error.errorMessage);
          err.name = error.name || error.errorClass;
          errorFramesToSkip = synthesizedErrorFramesToSkip;
        } else {
          err = createAndLogUsageError(error === null ? 'null' : 'unsupported object');
        }

        break;

      default:
        err = createAndLogUsageError('nothing');
    }

    return {
      err: err,
      errorFramesToSkip: errorFramesToSkip,
      _opts: _opts
    };
  };

  var hasNecessaryFields = function (error) {
    return (typeof error.name === 'string' || typeof error.errorClass === 'string') && (typeof error.message === 'string' || typeof error.errorMessage === 'string');
  };

  var generateConfigErrorMessage = function (errors) {
    return "traceit configuration error\n" + __map_4(errors, function (err) {
      return "\"" + err.key + "\" " + err.message + " \n    got " + stringify(err.value);
    }).join('\n\n');
  };

  var generateNotifyUsageMessage = function (actual) {
    return "notify() expected error/opts parameters, got " + actual;
  };

  var stringify = function (val) {
    return typeof val === 'object' ? JSON.stringify(val) : String(val);
  };

  var _$traceitClient = TraceitClient;

  var _$safeJsonStringify_19 = function (data, replacer, space, opts) {
    var filterKeys = opts && opts.filterKeys ? opts.filterKeys : [];
    var filterPaths = opts && opts.filterPaths ? opts.filterPaths : [];
    return JSON.stringify(prepareObjForSerialization(data, filterKeys, filterPaths), replacer, space);
  };

  var MAX_DEPTH = 20;
  var MAX_EDGES = 25000;
  var MIN_PRESERVED_DEPTH = 8;
  var REPLACEMENT_NODE = '...';

  function __isError_19(o) {
    return o instanceof Error || /^\[object (Error|(Dom)?Exception)\]$/.test(Object.prototype.toString.call(o));
  }

  function throwsMessage(err) {
    return '[Throws: ' + (err ? err.message : '?') + ']';
  }

  function find(haystack, needle) {
    for (var i = 0, len = haystack.length; i < len; i++) {
      if (haystack[i] === needle) return true;
    }

    return false;
  } 


  function isDescendent(paths, path) {
    for (var i = 0, len = paths.length; i < len; i++) {
      if (path.indexOf(paths[i]) === 0) return true;
    }

    return false;
  }

  function shouldFilter(patterns, key) {
    for (var i = 0, len = patterns.length; i < len; i++) {
      if (typeof patterns[i] === 'string' && patterns[i] === key) return true;
      if (patterns[i] && typeof patterns[i].test === 'function' && patterns[i].test(key)) return true;
    }

    return false;
  }

  function __isArray_19(obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  }

  function safelyGetProp(obj, prop) {
    try {
      return obj[prop];
    } catch (err) {
      return throwsMessage(err);
    }
  }

  function prepareObjForSerialization(obj, filterKeys, filterPaths) {
    var seen = []; // store references to objects we have seen before

    var edges = 0;

    function visit(obj, path) {
      function edgesExceeded() {
        return path.length > MIN_PRESERVED_DEPTH && edges > MAX_EDGES;
      }

      edges++;
      if (path.length > MAX_DEPTH) return REPLACEMENT_NODE;
      if (edgesExceeded()) return REPLACEMENT_NODE;
      if (obj === null || typeof obj !== 'object') return obj;
      if (find(seen, obj)) return '[Circular]';
      seen.push(obj);

      if (typeof obj.toJSON === 'function') {
        try {
          // we're not going to count this as an edge because it
          // replaces the value of the currently visited object
          edges--;
          var fResult = visit(obj.toJSON(), path);
          seen.pop();
          return fResult;
        } catch (err) {
          return throwsMessage(err);
        }
      }

      var er = __isError_19(obj);

      if (er) {
        edges--;
        var eResult = visit({
          name: obj.name,
          message: obj.message
        }, path);
        seen.pop();
        return eResult;
      }

      if (__isArray_19(obj)) {
        var aResult = [];

        for (var i = 0, len = obj.length; i < len; i++) {
          if (edgesExceeded()) {
            aResult.push(REPLACEMENT_NODE);
            break;
          }

          aResult.push(visit(obj[i], path.concat('[]')));
        }

        seen.pop();
        return aResult;
      }

      var result = {};

      try {
        for (var prop in obj) {
          if (!Object.prototype.hasOwnProperty.call(obj, prop)) continue;

          if (isDescendent(filterPaths, path.join('.')) && shouldFilter(filterKeys, prop)) {
            result[prop] = '[Filtered]';
            continue;
          }

          if (edgesExceeded()) {
            result[prop] = REPLACEMENT_NODE;
            break;
          }

          result[prop] = visit(safelyGetProp(obj, prop), path.concat(prop));
        }
      } catch (e) { }

      seen.pop();
      return result;
    }

    return visit(obj, []);
  }

  var _$jsonPayload_13 = {};


  var REPORT_FILTER_PATHS = ['events.[].app', 'events.[].customData', 'events.[].user', 'events.[].activities', 'events.[].request', 'events.[].device'];
  var SESSION_FILTER_PATHS = ['device', 'app', 'user'];

  _$jsonPayload_13.report = function (report, filterKeys) {
    var payload = _$safeJsonStringify_19(report, null, null, {
      filterPaths: REPORT_FILTER_PATHS,
      filterKeys: filterKeys
    });

    if (payload.length > 10e5) {
      delete report.events[0].customData;
      report.events[0].customData = {
        notifier: "WARNING!\nSerialized payload was " + payload.length / 10e5 + "MB (limit = 1MB)\nmetaData was removed"
      };
      payload = _$safeJsonStringify_19(report, null, null, {
        filterPaths: REPORT_FILTER_PATHS,
        filterKeys: filterKeys
      });
      if (payload.length > 10e5) throw new Error('payload exceeded 1MB limit');
    }

    return payload;
  };

  _$jsonPayload_13.session = function (report, filterKeys) {
    var payload = _$safeJsonStringify_19(report, null, null, {
      filterPaths: SESSION_FILTER_PATHS,
      filterKeys: filterKeys
    });
    if (payload.length > 10e5) throw new Error('payload exceeded 1MB limit');
    return payload;
  };

  var _$delivery_26 = {};
  var _this = this;

 
  var __isoDate_26 = _$esUtils.isoDate;

  _$delivery_26 = function (client, win) {
    if (win === void 0) {
      win = window;
    }

    return {
      sendReport: function (report, cb) {
        if (cb === void 0) {
          cb = function () { };
        }

        var url = getApiUrl(client.config, 'notify', '4', win);
       // console.log(url);
        var req = new win.XDomainRequest();

        req.onload = function () {
          cb(null);
        };

        req.open('POST', url);
        setTimeout(function () {
          try {
            req.send(_$jsonPayload_13.report(report, client.config.filters));
          } catch (e) {
            client._logger.error(e);

            cb(e);
          }
        }, 0);
      },
      sendSession: function (session, cb) {
        if (cb === void 0) {
          cb = function () { };
        }

        var url = getApiUrl(client.config, 'sessions', '1', win);
        //console.log(url);
        var req = new win.XDomainRequest();

        req.onload = function () {
          cb(null);
        };

        req.open('POST', url);
        setTimeout(function () {
          try {
            req.send(_$jsonPayload_13.session(session, client.config.filters));
          } catch (e) {
            _this._logger.error(e);

            cb(e);
          }
        }, 0);
      }
    };
  };

  var getApiUrl = function (config, endpoint, version, win) {
    return matchPageProtocol(config.endpoints[endpoint], win.location.protocol) + "?apiKey=" + encodeURIComponent(config.apiKey) + "&payloadVersion=" + version + "&sentAt=" + encodeURIComponent(__isoDate_26());
  };

  var matchPageProtocol = _$delivery_26._matchPageProtocol = function (endpoint, pageProtocol) {
    return pageProtocol === 'http:' ? endpoint.replace(/^https:/, 'http:') : endpoint;
  };

 

  var __isoDate_27 = _$esUtils.isoDate; 

  var __localDate_28 = _$esUtils.localDate;

  var _$delivery_27 = function (client, win) {
    if (win === void 0) {
      win = window;
    }

    return {
      sendReport: function (report, cb) {
        if (cb === void 0) {
          cb = function () { };
        }

        try {
          var url = client.config.endpoints.notify;
          var req = new win.XMLHttpRequest();
          //console.log(url);
          req.onreadystatechange = function () {
            if (req.readyState === win.XMLHttpRequest.DONE) cb(null);
          };

          req.open('POST', url);
          //req.withCredentials = true;
          req.setRequestHeader('Content-Type', 'application/json');
          req.setRequestHeader('traceit-Api-Key', report.apiKey || client.config.apiKey);
          req.setRequestHeader('traceit-Payload-Version', '1');
          req.setRequestHeader('traceit-Sent-At', __localDate_28());
          req.setRequestHeader('Author', 'IHX Team');
          req.setRequestHeader('Payload', '1');
          
          const payload = {
          errorType: JSON.stringify({ errorType: report.events[0].errorClass,
            severity: report.events[0].severity,
            severityReason: report.events[0]._handledState.severityReason.type}),
          errorDesc: JSON.stringify({
            message: report.events[0].errorMessage,
            stacktrace: report.events[0].stacktrace}),
          applicationName: JSON.stringify(report.events[0].app),
          fullDeviceInfo: report.events[0].device.userAgent,
          activities: JSON.stringify(report.events[0].activities),
          userDetails: report.events[0].user ? JSON.stringify({userId: report.events[0].user.userId, userName: report.events[0].user.userName, emailId: report.events[0].user.emailId}) : {},
          routeName: report.events[0].context,
          reportedBy: JSON.stringify(report.notifier),
          }
          
      //    req.setRequestHeader('Access-Control-Allow-Headers','Origin,Content-Type,Accept');
          req.send(JSON.stringify(payload));
        } catch (e) {
          client._logger.error(e);
        }
      },
      sendSession: function (session, cb) {
        if (cb === void 0) {
          cb = function () { };
        }

        try {
          var url = client.config.endpoints.sessions;
          var req = new win.XMLHttpRequest();
          //console.log(url);
          req.onreadystatechange = function () {
            if (req.readyState === win.XMLHttpRequest.DONE) cb(null);
          };

          req.open('POST', url);
         // req.withCredentials = true;
          req.setRequestHeader('Content-Type', 'application/json');
          req.setRequestHeader('traceit-Api-Key', client.config.apiKey);
          req.setRequestHeader('traceit-Payload-Version', '1');
          req.setRequestHeader('traceit-Sent-At', __localDate_28());
          req.setRequestHeader('Author', 'IHX Team');
          req.setRequestHeader('Payload', '0');
       //   req.setRequestHeader('Access-Control-Allow-Headers','Origin,Content-Type,Accept');
          req.send(_$jsonPayload_13.session(session, client.config.filters));
        } catch (e) {
          client._logger.error(e);
        }
      }
    };
  };

 
  var _$context_info = {
    init: function (client, win) {
      if (win === void 0) {
        win = window;
      }

      client.config.beforeSend.unshift(function (report) {
        if (report.context) return;
        report.context = win.location.pathname;
      });
    }
  };

  function ___extends_29() { ___extends_29 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ___extends_29.apply(this, arguments); }

  var __isoDate_29 = _$esUtils.isoDate;

  var __localdate_29 = _$esUtils.localDate;
 

  var _$device_info = {
    init: function (client, nav) {
      if (nav === void 0) {
        nav = navigator;
      }
	

      var device = {
        locale: nav.browserLanguage || nav.systemLanguage || nav.userLanguage || nav.language,
        userAgent: nav.userAgent 
      };
      client.device = ___extends_29({}, device, client.device); 

      client.config.beforeSend.unshift(function (report) {
        report.device = ___extends_29({}, report.device, {
          time: __localdate_29()
        });
      });
    }
  };

  function ___extends_30() { ___extends_30 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ___extends_30.apply(this, arguments); }

 
  var _$request_info = {
    init: function (client, win) {
      if (win === void 0) {
        win = window;
      }

      client.config.beforeSend.unshift(function (report) {
        if (report.request && report.request.url) return;
        report.request = ___extends_30({}, report.request, {
          url: win.location.href
        });
      });
    }
  };

  function ___extends_31() { ___extends_31 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ___extends_31.apply(this, arguments); }

  var __isArray_31 = _$esUtils.isArray,
    __includes_31 = _$esUtils.includes;


  var _$session_31 = {
    init: function (client) {
      return client.sessionDelegate(sessionDelegate);
    }
  };
  var sessionDelegate = {
    startSession: function (client) {
      var sessionClient = client;
      sessionClient._session = new client.TraceitSession();
      var deliveryStage = _$inferReleaseStage_10(sessionClient); 

      if (__isArray_31(sessionClient.config.notifyDeliveryStages) && !__includes_31(sessionClient.config.notifyDeliveryStages, deliveryStage)) {
        sessionClient._logger.warn("Session not sent due to deliveryStage/notifyDeliveryStages configuration");

        return sessionClient;
      }

      if (!sessionClient.config.endpoints.sessions) {
        sessionClient._logger.warn("Session not sent due to missing endpoints.sessions configuration");

        return sessionClient;
      }

      sessionClient._delivery.sendSession({
        notifier: sessionClient.notifier,
        device: sessionClient.device,
        app: ___extends_31({}, {
          deliveryStage: deliveryStage
        }, sessionClient.app),
        sessions: [{
          id: sessionClient._session.id,
          startedAt: sessionClient._session.startedAt,
          user: sessionClient.user
        }]
      });

      return sessionClient;
    }
  };

  function ___extends_32() { ___extends_32 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ___extends_32.apply(this, arguments); }

 
  var _$clientIp_32 = {
    init: function (client) {
      if (client.config.collectUserIp) return;
      client.config.beforeSend.push(function (report) {

        if (report.user && typeof report.user.id === 'undefined') delete report.user.id;
        report.user = ___extends_32({
          id: '[NOT COLLECTED]'
        }, report.user);
        report.request = ___extends_32({
          clientIp: '[NOT COLLECTED]'
        }, report.request);
      });
    },
    configSchema: {
      collectUserIp: {
        defaultValue: function () {
          return true;
        },
        message: 'should be true|false',
        validate: function (value) {
          return value === true || value === false;
        }
      }
    }
  };

  var _$consoleActivity = {};
  var __map_33 = _$esUtils.map,
    __reduce_33 = _$esUtils.reduce,
    __filter_33 = _$esUtils.filter;
 

  _$consoleActivity.init = function (client) {
    var isDev = /^dev(elopment)?$/.test(client.config.deliveryStage);
    var explicitlyDisabled = client.config.recordConsoleActivity === false;
    var implicitlyDisabled = (client.config.autoRecordActivites === false || isDev) && client.config.recordConsoleActivity !== true;
    if (explicitlyDisabled || implicitlyDisabled) return;
    __map_33(CONSOLE_LOG_METHODS, function (method) {
      var original = console[method];

      console[method] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        client.leaveActivity('Console output', __reduce_33(args, function (accum, arg, i) {
          var stringified = '[Unknown value]'; 

          try {
            stringified = String(arg);
          } catch (e) { } 


          if (stringified === '[object Object]') {
          
            try {
              stringified = JSON.stringify(arg);
            } catch (e) { }
          }

          accum["[" + i + "]"] = stringified;
          return accum;
        }, {
          severity: method.indexOf('group') === 0 ? 'log' : method
        }), 'log');
        original.apply(console, args);
      };

      console[method]._restore = function () {
        console[method] = original;
      };
    });
  };

  _$consoleActivity.configSchema = {
    recordConsoleActivity: {
      defaultValue: function () {
        return undefined;
      },
      validate: function (value) {
        return value === true || value === false || value === undefined;
      },
      message: 'should be true|false'
    }
  };

  if ("production" !== 'production') {
    _$consoleActivity.destroy = function () {
      return CONSOLE_LOG_METHODS.forEach(function (method) {
        if (typeof console[method]._restore === 'function') console[method]._restore();
      });
    };
  }

  var CONSOLE_LOG_METHODS = __filter_33(['log', 'debug', 'info', 'warn', 'error'], function (method) {
    return typeof console !== 'undefined' && typeof console[method] === 'function';
  });

  var __map_34 = _$esUtils.map,
    __reduce_34 = _$esUtils.reduce,
    __filter_34 = _$esUtils.filter;

  var MAX_LINE_LENGTH = 200;
  var MAX_SCRIPT_LENGTH = 500000;
  var _$inlineScriptContent_34 = {
    init: function (client, doc, win) {
      if (doc === void 0) {
        doc = document;
      }

      if (win === void 0) {
        win = window;
      }

      if (!client.config.captureInlineScripts) return;
      var originalLocation = win.location.href;
      var html = '';
      var DOMContentLoaded = false;

      var getHtml = function () {
        return doc.documentElement.outerHTML;
      }; 


      html = getHtml();
      var prev = doc.onreadystatechange; 

      doc.onreadystatechange = function () {

        if (doc.readyState === 'interactive') {
          html = getHtml();
          DOMContentLoaded = true;
        }

        try {
          prev.apply(this, arguments);
        } catch (e) { }
      };

      var _lastScript = null;

      var updateLastScript = function (script) {
        _lastScript = script;
      };

      var getCurrentScript = function () {
        var script = doc.currentScript || _lastScript;

        if (!script && !DOMContentLoaded) {
          var scripts = doc.scripts || doc.getElementsByTagName('script');
          script = scripts[scripts.length - 1];
        }

        return script;
      };

      var addSurroundingCode = function (lineNumber) {

        if (!DOMContentLoaded || !html) html = getHtml(); 

        var htmlLines = ['<!-- DOC START -->'].concat(html.split('\n'));
        var zeroBasedLine = lineNumber - 1;
        var start = Math.max(zeroBasedLine - 3, 0);
        var end = Math.min(zeroBasedLine + 3, htmlLines.length);
        return __reduce_34(htmlLines.slice(start, end), function (accum, line, i) {
          accum[start + 1 + i] = line.length <= MAX_LINE_LENGTH ? line : line.substr(0, MAX_LINE_LENGTH);
          return accum;
        }, {});
      };

      client.config.beforeSend.unshift(function (report) {

        report.stacktrace = __filter_34(report.stacktrace, function (f) {
          return !/__trace__$/.test(f.method);
        });
        var frame = report.stacktrace[0]; 

        if (frame && frame.file && frame.file.replace(/#.*$/, '') !== originalLocation.replace(/#.*$/, '')) return; 

        var currentScript = getCurrentScript();

        if (currentScript) {
          var content = currentScript.innerHTML;
          report.updateMetaData('script', 'content', content.length <= MAX_SCRIPT_LENGTH ? content : content.substr(0, MAX_SCRIPT_LENGTH));
        } 

        if (!frame || !frame.lineNumber) return;
        frame.code = addSurroundingCode(frame.lineNumber);
      }); 

      var _map = __map_34(['setTimeout', 'setInterval', 'setImmediate', 'requestAnimationFrame'], function (fn) {
        return __proxy(win, fn, function (original) {
          return __traceOriginalScript(original, function (args) {
            return {
              get: function () {
                return args[0];
              },
              replace: function (fn) {
                args[0] = fn;
              }
            };
          });
        });
      }),
        _setTimeout = _map[0]; 


      __map_34(['EventTarget', 'Window', 'Node', 'ApplicationCache', 'AudioTrackList', 'ChannelMergerNode', 'CryptoOperation', 'EventSource', 'FileReader', 'HTMLUnknownElement', 'IDBDatabase', 'IDBRequest', 'IDBTransaction', 'KeyOperation', 'MediaController', 'MessagePort', 'ModalWindow', 'Notification', 'SVGElementInstance', 'Screen', 'TextTrack', 'TextTrackCue', 'TextTrackList', 'WebSocket', 'WebSocketWorker', 'Worker', 'XMLHttpRequest', 'XMLHttpRequestEventTarget', 'XMLHttpRequestUpload'], function (o) {
        if (!win[o] || !win[o].prototype || !win[o].prototype.hasOwnProperty || !win[o].prototype.hasOwnProperty('addEventListener')) return;

        __proxy(win[o].prototype, 'addEventListener', function (original) {
          return __traceOriginalScript(original, eventTargetCallbackAccessor);
        });

        __proxy(win[o].prototype, 'removeEventListener', function (original) {
          return __traceOriginalScript(original, eventTargetCallbackAccessor, true);
        });
      });

      function __traceOriginalScript(fn, callbackAccessor, alsoCallOriginal) {
        if (alsoCallOriginal === void 0) {
          alsoCallOriginal = false;
        }

        return function () {
        
          var args = Array.prototype.slice.call(arguments);

          try {
            var cba = callbackAccessor(args);
            var cb = cba.get();
            if (alsoCallOriginal) fn.apply(this, args);
            if (typeof cb !== 'function') return fn.apply(this, args);

            if (cb.__trace__) {
              cba.replace(cb.__trace__);
            } else {
              var script = getCurrentScript();

              cb.__trace__ = function __trace__() {
                
                updateLastScript(script); 

                _setTimeout(function () {
                  updateLastScript(null);
                }, 0);

                var ret = cb.apply(this, arguments);
                updateLastScript(null);
                return ret;
              };

              cb.__trace__.__trace__ = cb.__trace__;
              cba.replace(cb.__trace__);
            }
          } catch (e) { } 

          if (fn.apply) return fn.apply(this, args);

          switch (args.length) {
            case 1:
              return fn(args[0]);

            case 2:
              return fn(args[0], args[1]);

            default:
              return fn();
          }
        };
      }
    },
    configSchema: {
      captureInlineScripts: {
        validate: function (value) {
          return value === true || value === false;
        },
        defaultValue: function () {
          return true;
        },
        message: 'should be true|false'
      }
    }
  };

  function __proxy(host, name, replacer) {
    var original = host[name];
    if (!original) return original;
    var replacement = replacer(original);
    host[name] = replacement;
    return original;
  }

  function eventTargetCallbackAccessor(args) {
    var isEventHandlerObj = !!args[1] && typeof args[1].handleEvent === 'function';
    return {
      get: function () {
        return isEventHandlerObj ? args[1].handleEvent : args[1];
      },
      replace: function (fn) {
        if (isEventHandlerObj) {
          args[1].handleEvent = fn;
        } else {
          args[1] = fn;
        }
      }
    };
  }


  var _$userInteractionActivity = {
    init: function (client, win) {
      if (win === void 0) {
        win = window;
      }

      if (!('addEventListener' in win)) return;
      var explicitlyDisabled = client.config.recordUserInteractionActivity === false;
      var implicitlyDisabled = client.config.autoRecordActivites === false && client.config.recordUserInteractionActivity !== true;
      if (explicitlyDisabled || implicitlyDisabled) return;
      win.addEventListener('click', function (event) {
        var targetText, targetSelector;

        try {
          targetText = getNodeText(event.target);
          targetSelector = getNodeSelector(event.target, win);
        } catch (e) {
          targetText = '[hidden]';
          targetSelector = '[hidden]';

          client._logger.error('Cross domain error when tracking click event.');
        }

        client.leaveActivity('UI click', {
          targetText: targetText,
          targetSelector: targetSelector
        }, 'user');
      }, true);
    },
    configSchema: {
      recordUserInteractionActivity: {
        defaultValue: function () {
          return undefined;
        },
        validate: function (value) {
          return value === true || value === false || value === undefined;
        },
        message: 'should be true|false'
      }
    } 

  };

  var getNodeText = function (el) {
    var text = el.textContent || el.innerText || '';
    if (!text && (el.type === 'submit' || el.type === 'button')) text = el.value;
    text = text.replace(/^\s+|\s+$/g, ''); 

    return truncate(text, 140);
  };


  function getNodeSelector(el, win) {
    var parts = [el.tagName];
    if (el.id) parts.push('#' + el.id);
    if (el.className && el.className.length) parts.push("." + el.className.split(' ').join('.')); 

    if (!win.document.querySelectorAll || !Array.prototype.indexOf) return parts.join('');

    try {
      if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join('');
    } catch (e) {
      
      return parts.join('');
    } 


    if (el.parentNode.childNodes.length > 1) {
      var index = Array.prototype.indexOf.call(el.parentNode.childNodes, el) + 1;
      parts.push(":nth-child(" + index + ")");
    }

    if (win.document.querySelectorAll(parts.join('')).length === 1) return parts.join(''); 

    if (el.parentNode) return getNodeSelector(el.parentNode, win) + " > " + parts.join('');
    return parts.join('');
  }

  function truncate(value, length) {
    var ommision = '(...)';
    if (value && value.length <= length) return value;
    return value.slice(0, length - ommision.length) + ommision;
  }

  var _$navigationActivity = {};
 
  _$navigationActivity.init = function (client, win) {
    if (win === void 0) {
      win = window;
    }

    if (!('addEventListener' in win)) return;
    var explicitlyDisabled = client.config.recordNavigationActivity === false;
    var implicitlyDisabled = client.config.autoRecordActivites === false && client.config.recordNavigationActivity !== true;
    if (explicitlyDisabled || implicitlyDisabled) return; 

    var drop = function (name) {
      return function () {
        return client.leaveActivity(name, {}, 'navigation');
      };
    }; 


    win.addEventListener('pagehide', drop('Page hidden'), true);
    win.addEventListener('pageshow', drop('Page shown'), true);
    win.addEventListener('load', drop('Page loaded'), true);
    win.document.addEventListener('DOMContentLoaded', drop('DOMContentLoaded'), true); 

    win.addEventListener('load', function () {
      return win.addEventListener('popstate', drop('Navigated back'), true);
    }); 

    win.addEventListener('hashchange', function (event) {
      var customData = event.oldURL ? {
        from: relativeLocation(event.oldURL, win),
        to: relativeLocation(event.newURL, win),
        state: getCurrentState(win)
      } : {
          to: relativeLocation(win.location.href, win)
        };
      client.leaveActivity('Hash changed', customData, 'navigation');
    }, true); 

    if (win.history.replaceState) wrapHistoryFn(client, win.history, 'replaceState', win);
    if (win.history.pushState) wrapHistoryFn(client, win.history, 'pushState', win);
    client.leaveActivity('traceit loaded', {}, 'navigation');
  };

  _$navigationActivity.configSchema = {
    recordNavigationActivity: {
      defaultValue: function () {
        return undefined;
      },
      validate: function (value) {
        return value === true || value === false || value === undefined;
      },
      message: 'should be true|false'
    }
  };

  if ("production" !== 'production') {
    _$navigationActivity.destroy = function (win) {
      if (win === void 0) {
        win = window;
      }

      win.history.replaceState._restore();

      win.history.pushState._restore();
    };
  } 


  var relativeLocation = function (url, win) {
    var a = win.document.createElement('A');
    a.href = url;
    return "" + a.pathname + a.search + a.hash;
  };

  var stateChangeToMetaData = function (win, state, title, url) {
    var currentPath = relativeLocation(win.location.href, win);
    return {
      title: title,
      state: state,
      prevState: getCurrentState(win),
      to: url || currentPath,
      from: currentPath
    };
  };

  var wrapHistoryFn = function (client, target, fn, win) {
    var orig = target[fn];

    target[fn] = function (state, title, url) {
      client.leaveActivity("History " + fn, stateChangeToMetaData(win, state, title, url), 'navigation');

      if (typeof client.refresh === 'function') client.refresh(); 

      if (client.config.autoRecordSessions) client.startSession(); 

      orig.apply(target, [state, title].concat(url !== undefined ? url : []));
    };

    if ("production" !== 'production') {
      target[fn]._restore = function () {
        target[fn] = orig;
      };
    }
  };

  var getCurrentState = function (win) {
    try {
      return win.history.state;
    } catch (e) { }
  };

  var _$networkActivity = {};
  var ACTIVITY_TYPE = 'request'; 

  var REQUEST_SETUP_KEY = 'BS~~S';
  var REQUEST_URL_KEY = 'BS~~U';
  var REQUEST_METHOD_KEY = 'BS~~M';

  var __includes_37 = _$esUtils.includes;

  var restoreFunctions = [];
  var client;
  var win;
  var getIgnoredUrls;

  var defaultIgnoredUrls = function () {
    return [client.config.endpoints.notify, client.config.endpoints.sessions];
  };
  


  _$networkActivity.name = 'networkActivities';

  _$networkActivity.init = function (_client, _getIgnoredUrls, _win) {
    if (_getIgnoredUrls === void 0) {
      _getIgnoredUrls = defaultIgnoredUrls;
    }

    if (_win === void 0) {
      _win = window;
    }

    var explicitlyDisabled = _client.config.recordNetworkActivity === false;
    var implicitlyDisabled = _client.config.autoRecordActivites === false && _client.config.recordNetworkActivity !== true;
    if (explicitlyDisabled || implicitlyDisabled) return;
    client = _client;
    win = _win;
    getIgnoredUrls = _getIgnoredUrls;
    monkeyPatchXMLHttpRequest();
    monkeyPatchFetch();
  };

  _$networkActivity.configSchema = {
    recordNetworkActivity: {
      defaultValue: function () {
        return undefined;
      },
      validate: function (value) {
        return value === true || value === false || value === undefined;
      },
      message: 'should be true|false'
    }
  };

  if ("production" !== 'production') {
    _$networkActivity.destroy = function () {
      restoreFunctions.forEach(function (fn) {
        return fn();
      });
      restoreFunctions = [];
    };
  } 


  var monkeyPatchXMLHttpRequest = function () {
    if (!('addEventListener' in win.XMLHttpRequest.prototype)) return;
    var nativeOpen = win.XMLHttpRequest.prototype.open; 

    win.XMLHttpRequest.prototype.open = function open(method, url) {
     
      this[REQUEST_URL_KEY] = url;
      this[REQUEST_METHOD_KEY] = method; 

      if (this[REQUEST_SETUP_KEY]) {
        this.removeEventListener('load', handleXHRLoad);
        this.removeEventListener('error', handleXHRError);
      } 


      this.addEventListener('load', handleXHRLoad); 

      this.addEventListener('error', handleXHRError);
      this[REQUEST_SETUP_KEY] = true;
      nativeOpen.apply(this, arguments);
    };

    if ("production" !== 'production') {
      restoreFunctions.push(function () {
        win.XMLHttpRequest.prototype.open = nativeOpen;
      });
    }
  };

  function handleXHRLoad() {
    if (__includes_37(getIgnoredUrls(), this[REQUEST_URL_KEY])) {
     
      return;
    }

    var customData = {
      status: this.status,
      request: this[REQUEST_METHOD_KEY] + " " + this[REQUEST_URL_KEY]
    };

    if (this.status >= 400) {
     
      client.leaveActivity('XMLHttpRequest failed', customData, ACTIVITY_TYPE);
    } else {
      client.leaveActivity('XMLHttpRequest succeeded', customData, ACTIVITY_TYPE);
    }
  }

  function handleXHRError() {
    if (__includes_37(getIgnoredUrls, this[REQUEST_URL_KEY])) {
      
      return;
    } 


    client.leaveActivity('XMLHttpRequest error', {
      request: this[REQUEST_METHOD_KEY] + " " + this[REQUEST_URL_KEY]
    }, ACTIVITY_TYPE);
  } 


  var monkeyPatchFetch = function () {

    if (!('fetch' in win) || win.fetch.polyfill) return;
    var oldFetch = win.fetch;

    win.fetch = function fetch() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var url = args[0],
        options = args[1];
      var method = 'GET';

      if (options && options.method) {
        method = options.method;
      }

      return new Promise(function (resolve, reject) {
        // pass through to native fetch
        oldFetch.apply(void 0, args).then(function (response) {
          handleFetchSuccess(response, method, url);
          resolve(response);
        })["catch"](function (error) {
          handleFetchError(method, url);
          reject(error);
        });
      });
    };

    if ("production" !== 'production') {
      restoreFunctions.push(function () {
        win.fetch = oldFetch;
      });
    }
  };

  var handleFetchSuccess = function (response, method, url) {
    var customData = {
      status: response.status,
      request: method + " " + url
    };

    if (response.status >= 400) {
      // when the request comes back with a 4xx or 5xx status it does not reject the fetch promise,
      client.leaveActivity('fetch() failed', customData, ACTIVITY_TYPE);
    } else {
      client.leaveActivity('fetch() succeeded', customData, ACTIVITY_TYPE);
    }
  };

  var handleFetchError = function (method, url) {
    client.leaveActivity('fetch() error', {
      request: method + " " + url
    }, ACTIVITY_TYPE);
  };

  var __intRange_38 = _$validators.intRange;



  var _$throttle_38 = {
    init: function (client) {
      // track sent events for each init of the plugin
      var n = 0; // add beforeSend hook

      client.config.beforeSend.push(function (report) {
        // have max events been sent already?
        if (n >= client.config.maxEvents) return report.ignore();
        n++;
      });

      client.refresh = function () {
        n = 0;
      };
    },
    configSchema: {
      maxEvents: {
        defaultValue: function () {
          return 10;
        },
        message: 'should be a positive integer ≤100',
        validate: function (val) {
          return __intRange_38(1, 100)(val);
        }
      }
    }
  };

  var _$stripQueryString_39 = {};
  function ___extends_39() { ___extends_39 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ___extends_39.apply(this, arguments); }

  /*
   * Remove query strings (and fragments) from stacktraces
   */
  var __map_39 = _$esUtils.map;

  _$stripQueryString_39 = {
    init: function (client) {
      client.config.beforeSend.push(function (report) {
        report.stacktrace = __map_39(report.stacktrace, function (frame) {
          return ___extends_39({}, frame, {
            file: strip(frame.file)
          });
        });
      });
    }
  };

  var strip = _$stripQueryString_39._strip = function (str) {
    return typeof str === 'string' ? str.replace(/\?.*$/, '').replace(/#.*$/, '') : str;
  };

  var _$onerror_40 = {
    init: function (client, win) {
      if (win === void 0) {
        win = window;
      }

      function onerror(messageOrEvent, url, lineNo, charNo, error) {
        // Ignore errors with no info due to CORS settings
        if (lineNo === 0 && /Script error\.?/.test(messageOrEvent)) {
          client._logger.warn('Ignoring cross-domain or eval script error');
        } else {
          // any error sent to window.onerror is unhandled and has severity=error
          var handledState = {
            severity: 'error',
            unhandled: true,
            severityReason: {
              type: 'unhandledException'
            }
          };
          var report; // window.onerror can be called in a number of ways. This big if-else is how we
          // figure out which arguments were supplied, and what kind of values it received.

          if (error) {
            // if the last parameter (error) was supplied, this is a modern browser's
            // way of saying "this value was thrown and not caught"
            if (error.name && error.message) {
              // if it looks like an error, construct a report object using its stack
              report = new client.TraceitReport(error.name, error.message, decorateStack(client.TraceitReport.getStacktrace(error), url, lineNo, charNo), handledState, error);
            } else {
              // otherwise, for non error values that were thrown, stringify it for
              // use as the error message and get/generate a stacktrace
              report = new client.TraceitReport('window.onerror', String(error), decorateStack(client.TraceitReport.getStacktrace(error, 1), url, lineNo, charNo), handledState, error); // include the raw input as customData

              report.updateMetaData('window onerror', {
                error: error
              });
            }
          } else if ( // This complex case detects "error" events that are typically synthesised
            // by jquery's trigger method (although can be created in other ways). In
            // order to detect this:
            // - the first argument (message) must exist and be an object (most likely it's a jQuery event)
            // - the second argument (url) must either not exist or be something other than a string (if it
            //    exists and is not a string, it'll be the extraParameters argument from jQuery's trigger()
            //    function)
            // - the third, fourth and fifth arguments must not exist (lineNo, charNo and error)
            typeof messageOrEvent === 'object' && messageOrEvent !== null && (!url || typeof url !== 'string') && !lineNo && !charNo && !error) {
            // The jQuery event may have a "type" property, if so use it as part of the error message
            var name = messageOrEvent.type ? "Event: " + messageOrEvent.type : 'window.onerror'; // attempt to find a message from one of the conventional properties, but
            // default to empty string (the report will fill it with a placeholder)

            var message = messageOrEvent.message || messageOrEvent.detail || '';
            report = new client.TraceitReport(name, message, client.TraceitReport.getStacktrace(new Error(), 1).slice(1), handledState, messageOrEvent); // include the raw input as customData – it might contain more info than we extracted

            report.updateMetaData('window onerror', {
              event: messageOrEvent,
              extraParameters: url
            });
          } else {
            // Lastly, if there was no "error" parameter this event was probably from an old
            // browser that doesn't support that. Instead we need to generate a stacktrace.
            report = new client.TraceitReport('window.onerror', String(messageOrEvent), decorateStack(client.TraceitReport.getStacktrace(error, 1), url, lineNo, charNo), handledState, messageOrEvent); // include the raw input as customData – it might contain more info than we extracted

            report.updateMetaData('window onerror', {
              event: messageOrEvent
            });
          }

          client.notify(report);
        }

        if (typeof prevOnError === 'function') prevOnError.apply(this, arguments);
      }

      var prevOnError = win.onerror;
      win.onerror = onerror;
    } // Sometimes the stacktrace has less information than was passed to window.onerror.
    // This function will augment the first stackframe with any useful info that was
    // received as arguments to the onerror callback.

  };

  var decorateStack = function (stack, url, lineNo, charNo) {
    var culprit = stack[0];
    if (!culprit) return stack;
    if (!culprit.fileName && typeof url === 'string') culprit.setFileName(url);
    if (!culprit.lineNumber && isActualNumber(lineNo)) culprit.setLineNumber(lineNo);

    if (!culprit.columnNumber) {
      if (isActualNumber(charNo)) {
        culprit.setColumnNumber(charNo);
      } else if (window.event && isActualNumber(window.event.errorCharacter)) {
        culprit.setColumnNumber(window.event.errorCharacter);
      }
    }

    return stack;
  };

  var isActualNumber = function (n) {
    return typeof n === 'number' && String.call(n) !== 'NaN';
  };

  var _$unhandledRejection_41 = {};
 

  var __reduce_41 = _$esUtils.reduce;

 
  var _listener;

  _$unhandledRejection_41.init = function (client, win) {
    if (win === void 0) {
      win = window;
    }

    var listener = function (event) {
      var error = event.reason;
      var isBluebird = false; // accessing properties on event.detail can throw errors (see #394)

      try {
        if (event.detail && event.detail.reason) {
          error = event.detail.reason;
          isBluebird = true;
        }
      } catch (e) { }

      var handledState = {
        severity: 'error',
        unhandled: true,
        severityReason: {
          type: 'unhandledPromiseRejection'
        }
      };
      var report;

      if (error && _$hasStack_9(error)) {
        // if it quacks like an Error…
        report = new client.TraceitReport(error.name, error.message, _$errorStackParser_7.parse(error), handledState, error);

        if (isBluebird) {
          report.stacktrace = __reduce_41(report.stacktrace, fixBluebirdStacktrace(error), []);
        }
      } else {
        // if it doesn't…
        var msg = 'Rejection reason was not an Error. See "Promise" tab for more detail.';
        report = new client.TraceitReport(error && error.name ? error.name : 'UnhandledRejection', error && error.message ? error.message : msg, [], handledState, error); // stuff the rejection reason into customData, it could be useful

        report.updateMetaData('promise', 'rejection reason', serializableReason(error));
      }

      client.notify(report);
    };

    if ('addEventListener' in win) {
      win.addEventListener('unhandledrejection', listener);
    } else {
      win.onunhandledrejection = function (reason, promise) {
        listener({
          detail: {
            reason: reason,
            promise: promise
          }
        });
      };
    }

    _listener = listener;
  };

  if ("production" !== 'production') {
    _$unhandledRejection_41.destroy = function (win) {
      if (win === void 0) {
        win = window;
      }

      if (_listener) {
        if ('addEventListener' in win) {
          win.removeEventListener('unhandledrejection', _listener);
        } else {
          win.onunhandledrejection = null;
        }
      }

      _listener = null;
    };
  }

  var serializableReason = function (err) {
    if (err === null || err === undefined) {
      return 'undefined (or null)';
    } else if (_$iserror_11(err)) {
      var _ref;

      return _ref = {}, _ref[Object.prototype.toString.call(err)] = {
        name: err.name,
        message: err.message,
        code: err.code,
        stack: err.stack
      }, _ref;
    } else {
      return err;
    }
  }; 

  var fixBluebirdStacktrace = function (error) {
    return function (accum, frame) {
      if (frame.file === error.toString()) return accum;

      if (frame.method) {
        frame.method = frame.method.replace(/^\s+/, '');
      }

      return accum.concat(frame);
    };
  };

  var _$traceit_notifier = {};
  function ___extends_2() { ___extends_2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ___extends_2.apply(this, arguments); }

  var name = 'traceit';
  var version = '1.00';
  var url = ' ';



  var __schema_2 = ___extends_2({}, _$traceit_config.schema, _$config_1);



  _$traceit_notifier = function (opts) {
 
    if (typeof opts === 'string') opts = {
      apiKey: opts 

    };
    var warningMessage = '';

    if (opts.endpoints && opts.endpoints.notify && !opts.endpoints.sessions) {
      warningMessage += 'notify endpoint is set but sessions endpoint is not. No sessions will be sent.';
    }

    var traceit = new _$traceitClient({
      name: name,
      version: version,
      url: url
    });
    traceit.setOptions(opts); 

    traceit.delivery(window.XDomainRequest ? _$delivery_26 : _$delivery_27); 

    traceit.configure(__schema_2);
    if (warningMessage) traceit._logger.warn(warningMessage); 

    traceit.use(_$device_info);
    traceit.use(_$context_info);
    traceit.use(_$request_info);
    traceit.use(_$throttle_38);
    traceit.use(_$session_31);
    traceit.use(_$clientIp_32);
    traceit.use(_$stripQueryString_39); 

    if (traceit.config.autoNotify !== false) {
      traceit.use(_$onerror_40);
      traceit.use(_$unhandledRejection_41);
    }

    traceit.use(_$navigationActivity);
    traceit.use(_$userInteractionActivity);
    traceit.use(_$networkActivity);
    traceit.use(_$consoleActivity); 

    traceit.use(_$inlineScriptContent_34);

    traceit._logger.debug("Loaded!");

    return traceit.config.autoRecordSessions ? traceit.startSession() : traceit;
  }; 


  _$traceit_notifier.Traceit = {
    Client: _$traceitClient,
    Report: _$traceitReport,
    Session: _$traceitSession,
    Activity: _$traceitActivity

  };
  _$traceit_notifier['default'] = _$traceit_notifier;

  return _$traceit_notifier;

});





